/*
	Quick JS by Jason @ freakdesign.
	Questions? Ping me on twitter: @freakdesign
	Relates to blog post:
	https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
	Example:
	https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/
(function () {
	"use strict";
	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;
	var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if (shippingCalcExist) return;
	/* The ID of the element that you want to add the shipping fields into */
	var productSection = document.querySelector('.shopping-calculator');
	if (!productSection) { log('Could not find the element'); return }
	/* the main product select element */
	var productSelect = document.querySelector('.product-form form input[name="id"]');
	if (!productSelect) { log('Could not find the main select element'); return }
	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function () {
		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i === 0));
		};
		shippingCountry.name = 'shipping_address[country]';
		/* create the province state picker */
		var provinces = ['Santa Catarina'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
		};
		shippingProvince.name = 'shipping_address[province]';
		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
		shippingZip.pattern = '[0-9]*';
		shippingZip.inputMode = 'numeric';
		shippingZip.value = '';
		shippingZip.placeholder = 'Insira seu CEP';
		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('div');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';
		/* create a not know my zip code message */
		var shippingCalcNoZip = document.createElement('a');
		shippingCalcNoZip.className = 'shipping-calc-no-zip';
		shippingCalcNoZip.innerText = 'Não sei meu CEP';
		shippingCalcNoZip.href = 'https://buscacepinter.correios.com.br/app/endereco/index.php';
		shippingCalcNoZip.target = '_blank';
		/* create a icon */
		var shippingCalcIcon = document.createElement('span');
		var shippinIconHtml = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.1956 10.9688L21.8831 7.6875C21.7718 7.40988 21.5796 7.17209 21.3316 7.00494C21.0835 6.83778 20.791 6.74897 20.4919 6.75H17.25V6C17.25 5.80109 17.171 5.61032 17.0303 5.46967C16.8897 5.32902 16.6989 5.25 16.5 5.25H2.25C1.85218 5.25 1.47064 5.40804 1.18934 5.68934C0.908035 5.97064 0.75 6.35218 0.75 6.75V17.25C0.75 17.6478 0.908035 18.0294 1.18934 18.3107C1.47064 18.592 1.85218 18.75 2.25 18.75H3.84375C4.00898 19.3953 4.38428 19.9673 4.91048 20.3757C5.43669 20.7842 6.08387 21.0059 6.75 21.0059C7.41613 21.0059 8.06331 20.7842 8.58952 20.3757C9.11573 19.9673 9.49102 19.3953 9.65625 18.75H14.3438C14.509 19.3953 14.8843 19.9673 15.4105 20.3757C15.9367 20.7842 16.5839 21.0059 17.25 21.0059C17.9161 21.0059 18.5633 20.7842 19.0895 20.3757C19.6157 19.9673 19.991 19.3953 20.1563 18.75H21.75C22.1478 18.75 22.5294 18.592 22.8107 18.3107C23.092 18.0294 23.25 17.6478 23.25 17.25V11.25C23.2503 11.1536 23.2318 11.0581 23.1956 10.9688ZM17.25 8.25H20.4919L21.3919 10.5H17.25V8.25ZM2.25 6.75H15.75V12.75H2.25V6.75ZM6.75 19.5C6.45333 19.5 6.16332 19.412 5.91665 19.2472C5.66997 19.0824 5.47771 18.8481 5.36418 18.574C5.25065 18.2999 5.22094 17.9983 5.27882 17.7074C5.3367 17.4164 5.47956 17.1491 5.68934 16.9393C5.89912 16.7296 6.16639 16.5867 6.45737 16.5288C6.74834 16.4709 7.04994 16.5006 7.32403 16.6142C7.59811 16.7277 7.83238 16.92 7.9972 17.1666C8.16203 17.4133 8.25 17.7033 8.25 18C8.25 18.3978 8.09197 18.7794 7.81066 19.0607C7.52936 19.342 7.14783 19.5 6.75 19.5ZM14.3438 17.25H9.65625C9.49102 16.6047 9.11573 16.0327 8.58952 15.6243C8.06331 15.2158 7.41613 14.9941 6.75 14.9941C6.08387 14.9941 5.43669 15.2158 4.91048 15.6243C4.38428 16.0327 4.00898 16.6047 3.84375 17.25H2.25V14.25H15.75V15.4041C15.4051 15.6034 15.1032 15.8692 14.8619 16.1861C14.6205 16.5029 14.4444 16.8646 14.3438 17.25ZM17.25 19.5C16.9533 19.5 16.6633 19.412 16.4166 19.2472C16.17 19.0824 15.9777 18.8481 15.8642 18.574C15.7507 18.2999 15.7209 17.9983 15.7788 17.7074C15.8367 17.4164 15.9796 17.1491 16.1893 16.9393C16.3991 16.7296 16.6664 16.5867 16.9574 16.5288C17.2483 16.4709 17.5499 16.5006 17.824 16.6142C18.0981 16.7277 18.3324 16.92 18.4972 17.1666C18.662 17.4133 18.75 17.7033 18.75 18C18.75 18.3978 18.592 18.7794 18.3107 19.0607C18.0294 19.342 17.6478 19.5 17.25 19.5ZM21.75 17.25H20.1563C19.989 16.6063 19.613 16.0362 19.0871 15.629C18.5612 15.2218 17.9151 15.0006 17.25 15V12H21.75V17.25Z" fill="currentColor" /></svg>`;
		shippingCalcIcon.innerHTML = shippinIconHtml;
		shippingCalcIcon.classList.add('shipping-calc-icon');
		/* create a title */
		var shippingCalcTitle = document.createElement('h3');
		shippingCalcTitle.classList.add('shipping-calc-title');
		shippingCalcTitle.innerText = 'Calcule o valor do frete e o prazo para sua região.';
		shippingCalcTitle.appendChild(shippingCalcIcon);
		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Ok';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcButton.onclick = function () {
			checkRegionOnZip(shippingZip.value);
			if (!productSelect.value.length) { return false }
			if (shippingZip.value != '') {
				shippingCalcButton.innerText = 'Calculando...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();
			/* if not found, make a new temp cookie */
			if (!cartCookie) {
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			} else {
				log('cookie found');
			}
			/* if found but has a weird length, bail */
			if (cartCookie.length < 32) { log('cart ID not valid'); return }
			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));
			getRates(parseInt(productSelect.value));
			return false;
		};
		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};
		shippingCalcWrapper.appendChild(shippingCalcTitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(shippingCalcNoZip);
		shippingCalcWrapper.appendChild(shippingMessage);
		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);
	};
	/* A console logging function */
	function log(a) {
		if (!debug) { return }
		console.log(a);
	};
	/* get cookie by name */
	var getCookie = function (name) {
		var value = "; " + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};
	/* update the cart cookie value */
	var updateCartCookie = function (a) {
		log('changing cart cookie value to: ' + a);
		var date = new Date();
		date.setTime(date.getTime() + (14 * 86400000));
		var expires = '; expires=' + date.toGMTString();
		document.cookie = 'cart=' + a + expires + '; path=/';
	};
	/* reset the cart cookie value */
	var resetCartCookie = function () {
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};
	/* get the rates */
	var getRates = function (variantId) {
		/* add whatever sanity checks you need in addition to the one below */
		if (typeof variantId === 'undefined') { return }
		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');
		var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
		var addData = {
			'id': variantId,
			'quantity': quantity
		};
		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function (response) {
			return response.json();
		}).then(function (json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */
			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]': shippingCountry.value,
				'shipping_address[province]': shippingProvince.value,
				'shipping_address[zip]': shippingZip.value
			})).then(function (response) {
				if (!response.ok) {
					return response.json().then(function (errorData) {
						throw new Error('Não foi possível calcular o frete. Por favor, verifique o CEP e tente novamente.');
					});
				}
				return response.json();
			}).then(function (result) {
				if (result.shipping_rates && result.shipping_rates.length) {
					let messageHtml = '<ul>'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
						if (element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								var deliveryDays = '<span>1 dia útil</span>'
							} else {
								var deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}
						if (element.price > 0) {
							messageHtml += `
								<li> 
									R$ ${element.price.replace('.', ',')} - ${deliveryDays ? deliveryDays : ''}
								</li>
							`;
						} else {
							messageHtml += `
								<li>
									<span style="color: #00AA00;">GRÁTIS</span> - ${deliveryDays ? deliveryDays : ''}
								</li>
							`;
						}
						if (i === result.shipping_rates.length) {
							messageHtml += '</ul>'
						}
					}
					shippingMessage.innerHTML = messageHtml;
				} else {
					shippingMessage.innerHTML = '<p style="color: #ff5414;">Não há opções de entrega disponíveis para este CEP.</p>';
				}
				document.querySelector('.shippingCalcButton').innerText = 'Calcular';
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
				resetCartCookie();
			}).catch(function (error) {
				console.log(error);
				resetCartCookie();
				shippingMessage.innerHTML = `<p style="color: #ff5414;">${error.message}</p>`;
				document.querySelector('.shippingCalcButton').innerText = 'Calcular';
				document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
			})
		}).catch(function (err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});
	};
	initFields();
})()